import { Card, CardActions, CardContent } from "@mui/material";
import * as React from "react";
import {
  BasicAccountApplicationItemClassNameBase,
  StandardBasicAccountApplicationItemProps,
} from "../types";

import CustomTypography from "../../typography";
import "../styles.scss";

const classNameBase = "status-open " + BasicAccountApplicationItemClassNameBase;

export default function AccountApplicationOpenItem(
  props: StandardBasicAccountApplicationItemProps,
): React.JSX.Element {
  const { product, image, title, button } = props;

  return (
    <Card className={`${classNameBase}`} color={product}>
      <CardContent className={`${classNameBase}-content-open`} component="div">
        <div className="scd-item-content">
          {image}
          <div className="scd-application-item-info">
            <CustomTypography className="item-title" variant="h4">
              {title}
            </CustomTypography>
          </div>
        </div>
        <CardActions className={`${classNameBase}-actions`}>
          {button}
        </CardActions>
      </CardContent>
    </Card>
  );
}
